export default [
  {
    name: 'ADMIN',
    title: 'Everything',
    description: 'Able to perform all actions',
  },
  {
    name: 'MANAGE_USERS',
    title: 'Users',
    description: 'Able to invite and remove users',
  },
  {
    name: 'MANAGE_PERMISSIONS',
    title: 'User Permissions',
    description: "Able to manage a user's permissions",
  },
  {
    name: 'MANAGE_DELETIONS',
    title: 'Deletions',
    description: 'Able to delete resources',
  },
  {
    name: 'MANAGE_ACTIVITY',
    title: 'Activity Access',
    description: 'Able to access the activity log',
  },
  {
    name: 'MANAGE_COMPANIES',
    title: 'Companies',
    description: 'Able to manage companies',
  },
  {
    name: 'MANAGE_DRIVERS',
    title: 'Drivers',
    description: 'Able to manage drivers',
  },
  {
    name: 'MANAGE_VEHICLES',
    title: 'Vehicles',
    description: 'Able to manage vehicles',
  },
  {
    name: 'MANAGE_VEHICLE_TYPES',
    title: 'Vehicle Types',
    description: 'Able to manage vehicle types',
  },
  {
    name: 'MANAGE_HOLIDAYS',
    title: 'Holidays',
    description: 'Able to manage holidays',
  },
  {
    name: 'MANAGE_RESERVATIONS',
    title: 'Reservations',
    description: 'Able to manage vehicle reservations',
  },
  {
    name: 'MANAGE_ACCESSORIES',
    title: 'Accessories',
    description: 'Able to manage accessories',
  },
  {
    name: 'MANAGE_BOOKINGS',
    title: 'Bookings',
    description: 'Able to manage bookings',
  },
  {
    name: 'MANAGE_PAYMENTS',
    title: 'Payments',
    description: 'Able to manage payments',
  },
  {
    name: 'MANAGE_SETTINGS',
    title: 'Settings',
    description: 'Able to manage global settings',
  },
  {
    name: 'MANAGE_SERVICE',
    title: 'Servicing',
    description: 'Able to manage vehicle services',
  },
];
